"use client";

import dynamic from "next/dynamic";
import type { ZipCodeConnectedProps } from "dds/molecules/zip-code/zip-code-connected.client";

/**
 * `ZipCodeConnected`, in a chunk of its own.
 *
 * ⚠ THE `"use client"` ABOVE IS THE WHOLE POINT. `next/dynamic` called from a SERVER
 * Component does not split a CLIENT one, and every module that reaches this — the
 * `fill-*-slots.tsx` fillers, `slot-fillers.ts`, and `v3-main-canvas.tsx` which
 * imports them STATICALLY — is a server module. Referenced from there directly, the
 * ZIP Code's ~2,600 client lines (the molecule, `services/zip`, TextField, Dropdown,
 * Tooltip) land in the shared entry chunk for `app/v3/[...slug]` and download on
 * every v3 page, carousel or not. Only this file's own boundary splits them.
 *
 * No `ssr: false`: the server HTML keeps the slot's height stable, so the carousel does
 * not shift when the chunk lands.
 */
export const ZipCodeLazy = dynamic<ZipCodeConnectedProps>(
  () => import("dds/molecules/zip-code/zip-code-connected.client").then(m => m.ZipCodeConnected)
);

export default ZipCodeLazy;
